import * as React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import LocalBtn from './LocalBtn';
import { SerializedStyles } from '@emotion/core';


interface Props extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  /**
   * The translation key to lookup for the button text
   */
  str: string | number;

  /**
   * Fallback text to be used for the translated button text can't be found
   */
  defaultText?: string;

  /**
   * Optional FontAwesome icon; renders left of the button text in LTR, right in RTL
   */
  icon?: IconDefinition;

  /**
   * Optional styling for the font awesome icon
   */
  iconStyle?: SerializedStyles;
}


/**
 * MobileToolbarBtn: a component that renders a button styled specifically for mobile toolbars
 *
 * PureComponent: true
 * Redux Connected: false
 */
const MobileToolbarBtn: React.FC<Props> = props => (
  <LocalBtn {...props} useMobileToolbarStyling={true} />
);

export default MobileToolbarBtn;
